/**
 * TileFilter — gear chips on a creator collection page
 *
 * Markup contract (sections/collection-main.liquid):
 *   [data-tile-filter]           → chip row
 *   [data-tile-filter-key="key"] → chip ("all" or an instrument-map key)
 *   [data-tile-list]             → list of detailed tiles
 *   [data-tile-item]             → one tile, carrying data-instrument
 *   [data-tile-empty]            → empty-state message
 *
 * Client-side only, mirroring the homepage catalog's filtering: hides tiles
 * whose data-instrument doesn't match. Filtering applies to the current page
 * of results (pagination is server-side).
 */
class TileFilter {
  constructor(bar) {
    this.bar = bar;
    this.list = document.querySelector('[data-tile-list]');
    this.empty = document.querySelector('[data-tile-empty]');
    this.key = 'all';

    this.bar.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-tile-filter-key]');
      if (!chip) return;
      this.apply(chip.dataset.tileFilterKey);
    });

    // Load-more (assets/infinite-scroll.js) appends new tiles into the list —
    // re-apply the active filter so they arrive already filtered.
    if (this.list) {
      new MutationObserver(() => this.apply(this.key)).observe(this.list, { childList: true });
    }
  }

  apply(key) {
    this.key = key;

    this.bar.querySelectorAll('[data-tile-filter-key]').forEach((chip) => {
      chip.classList.toggle('is-active', chip.dataset.tileFilterKey === key);
    });

    const items = this.list ? this.list.querySelectorAll('[data-tile-item]') : [];
    let visible = 0;
    items.forEach((item) => {
      const show = key === 'all' || item.dataset.instrument === key;
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (this.empty) this.empty.hidden = visible > 0;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-tile-filter]');
  if (bar) new TileFilter(bar);
});
